import { render, staticRenderFns } from "./website-about.vue?vue&type=template&id=a0eb6484&scoped=true&"
import script from "./website-about.vue?vue&type=script&lang=js&"
export * from "./website-about.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eb6484",
  null
  
)

export default component.exports